import request from '@/utils/request'
import qs from 'qs'

// arrival guest menu
export function getBookingInfo(query = {}) {
  return request({
    url: '/booking-service/v1/booking-info/list',
    // url: '/booking-service/v1/booking-info',
    method: 'get',
    params: query
  })
}
export function getBookingInfoDetail(query = {}) {
  return request({
    url: '/booking-service/v1/booking-info/detail',
    method: 'get',
    params: query
  })
}
export function setBookingMaster(query = { isMaster: true, bookingId: null }) {
  return request({
    url: '/booking-service/v1/booking/master-setting',
    method: 'patch',
    params: query
  })
}
export function separateFromGroup(query = { bookingId: null }) {
  return request({
    url: '/booking-service/v1/booking/separate-group',
    method: 'patch',
    params: query
  })
}

export function getJoinGroup(
  query = { bookingCode1: null, bookingCode2: null }
) {
  return request({
    url: '/booking-service/v1/booking/join-group',
    method: 'get',
    params: query
  })
}
export function joinGroup(data) {
  return request({
    url: '/booking-service/v1/booking/join-group',
    method: 'put',
    data
  })
}

export function checkin(data) {
  return request({
    url: '/booking-service/v1/booking/check-in',
    method: 'post',
    data
  })
}
export function cancelBooking(query) {
  return request({
    url: '/booking-service/v1/booking/cancel',
    method: 'patch',
    data: query
  })
}

export function cancelAnyBooking(query = { ids: null, cancel_reason: '' }) {
  return request({
    url: '/booking-service/v1/booking/cancel',
    method: 'patch',
    data: query
  })
}
export function changeRoomBooking(data) {
  return request({
    url: '/booking-service/v1/booking/change-room',
    method: 'post',
    data
  })
}
export function extendRoomBooking(data) {
  return request({
    url: '/booking-service/v1/booking/extend',
    method: 'post',
    data
  })
}

// assign room
export function getAssignRoom(query = {}) {
  return request({
    url: '/booking-service/v1/receptionist/assign-room',
    method: 'get',
    params: query
  })
}
export function assignRoom(data = {}) {
  return request({
    url: '/booking-service/v1/booking/assign-room',
    method: 'post',
    data
  })
}

// hotel status menu
export function getHotelStatus(query = {}) {
  return request({
    url: '/booking-service/v1/receptionist/hotel-status',
    method: 'get',
    params: query
  })
}
export function getHotelStatusDetail(query = {}) {
  return request({
    url: '/booking-service/v1/receptionist/hotel-status-detail',
    method: 'get',
    params: query
  })
}

// birthday
export function getBirthDay(query) {
  return request({
    url: '/booking-service/v1/receptionist/birth-day',
    method: 'get',
    params: query
  })
}

// room available
export function getRoomAvailable(query) {
  return request({
    url: '/booking-service/v1/receptionist/room-avail',
    method: 'get',
    params: query
  })
}
export function getRoomAvailableExcel(query) {
  return request({
    url: '/booking-service/v1/receptionist/room-avail-excel',
    method: 'get',
    params: query,
    responseType: 'blob'
  })
}
// in dialog booking status of menu room availability
export function getBookingStatus(query) {
  return request({
    url: '/booking-service/v1/booking/booking-status',
    method: 'get',
    params: query,
    // paramsSerializer: query =>
    //   qs.stringify(query, {
    //     arrayFormat: 'repeat',
    //     encode: false
    //   })
    paramsSerializer: query => {
      return qs.stringify(query, { arrayFormat: 'repeat' })
    }
  })
}

// room status
export function getRoomStatus(query) {
  return request({
    url: '/booking-service/v1/receptionist/room-status',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false,
        skipNulls: true
      })
    }
  })
}
export function getRoomStatusExcel(query) {
  return request({
    url: '/booking-service/v1/receptionist/room-status-excel',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false,
        skipNulls: true
      })
    },
    responseType: 'blob'
  })
}
export function exportCard(query) {
  return request({
    url: '/booking-service/v1/booking/export-ticket-combo',
    method: 'post',
    data: query
    // paramsSerializer: query => {
    //   return qs.stringify(query, {
    //     arrayFormat: 'repeat',
    //     encode: false,
    //     skipNulls: true
    //   })
    // }
  })
}

export function getTicketForPrintApi(query) {
  return request({
    url: '/config-ticket-service/v1/agent/ticket-sales/ticket',
    method: 'get',
    params: query
  })
}

export function putPrintCountApi(query) {
  return request({
    url: '/config-ticket-service/v1/agent/ticket-sales/print-invoice',
    method: 'put',
    params: query
  })
}

export function getHotelLinkDashboard(params) {
  return request({
    url: '/booking-service/v1/receptionist/hotel-link-dashboard',
    method: 'get',
    params
  })
}
